import React, { createContext } from 'react';

export const WorkOrderContext = createContext(null);

export const withWorkOrderContext = Component => props => (
  <WorkOrderContext.Consumer>
    {workOrder => <Component {...props} workOrderContext={workOrder} />}
  </WorkOrderContext.Consumer>
);